export default __webpack_public_path__ + "static/media/ts_help4.663a4532.png";